const isMobileDevice = () => /Mobi|Android/i.test(navigator.userAgent);

const isIOSDevice = () =>
  /iPad|iPhone|iPod/i.test(navigator.userAgent) ||
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

export { isMobileDevice, isIOSDevice };
